"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = AcceptButton;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_native_1 = require("react-native");
const react_native_linear_gradient_1 = __importDefault(require("react-native-linear-gradient"));
const react_native_fontawesome_1 = require("@fortawesome/react-native-fontawesome");
const pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
const colors_1 = require("../../../common/colors");
function AcceptButton(props) {
    return ((0, jsx_runtime_1.jsx)(react_native_1.Pressable, { ...props, children: (0, jsx_runtime_1.jsx)(react_native_linear_gradient_1.default, { colors: colors_1.Colors.CTA_GRADIENT_2, locations: [0.0479, 0.9512], useAngle: true, angle: 204, style: styles.button, children: (0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faCheck, color: colors_1.Colors.white, size: 14 }) }) }));
}
;
const styles = react_native_1.StyleSheet.create({
    button: {
        padding: 9,
        borderRadius: 56,
    },
});
